export const Volume = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9217)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.6426 34.7673C49.0445 34.934 49.388 35.216 49.6296 35.5779C49.8712 35.9397 50 36.365 50 36.8001V63.2001C49.9999 63.6353 49.8708 64.0605 49.6291 64.4222C49.3873 64.7839 49.0438 65.0657 48.6418 65.2322C48.2399 65.3988 47.7976 65.4423 47.3709 65.3574C46.9442 65.2725 46.5523 65.0631 46.2446 64.7555L38.0892 56.6001H32.4C31.8165 56.6001 31.2569 56.3684 30.8444 55.9557C30.4318 55.5432 30.2 54.9835 30.2 54.4001V45.6001C30.2 45.0167 30.4318 44.4571 30.8444 44.0445C31.2569 43.6319 31.8165 43.4001 32.4 43.4001H38.0892L46.2446 35.2447C46.5523 34.9369 46.9443 34.7272 47.3712 34.6422C47.798 34.5572 48.2405 34.6008 48.6426 34.7673ZM60.2454 34.4439C60.6579 34.0315 61.2174 33.7998 61.8008 33.7998C62.3842 33.7998 62.9437 34.0315 63.3562 34.4439C65.4018 36.4848 67.024 38.9096 68.13 41.5792C69.2357 44.2488 69.8033 47.1106 69.8 50.0001C69.8033 52.8898 69.2357 55.7516 68.13 58.421C67.024 61.0907 65.4018 63.5156 63.3562 65.5563C62.9413 65.9571 62.3856 66.1789 61.8087 66.1738C61.2319 66.1688 60.6801 65.9373 60.2722 65.5295C59.8644 65.1216 59.6329 64.5698 59.6279 63.993C59.6228 63.4161 59.8446 62.8604 60.2454 62.4455C61.8824 60.8133 63.1806 58.8734 64.0653 56.7376C64.9501 54.6016 65.4035 52.3119 65.4 50.0001C65.4 45.1381 63.4332 40.7425 60.2454 37.5547C59.8329 37.1422 59.6012 36.5827 59.6012 35.9993C59.6012 35.416 59.8329 34.8565 60.2454 34.4439ZM54.0216 40.6655C54.226 40.461 54.4686 40.2987 54.7357 40.188C55.0028 40.0773 55.289 40.0203 55.5781 40.0203C55.8672 40.0203 56.1534 40.0773 56.4205 40.188C56.6876 40.2987 56.9302 40.461 57.1346 40.6655C58.362 41.8902 59.3353 43.3453 59.9986 44.9472C60.6619 46.5491 61.0022 48.2663 61 50.0001C61.0022 51.7339 60.6619 53.451 59.9983 55.0531C59.335 56.6549 58.3618 58.11 57.1346 59.3347C56.7219 59.7476 56.162 59.9795 55.5781 59.9795C54.9942 59.9795 54.4343 59.7476 54.0216 59.3347C53.6089 58.922 53.3768 58.3621 53.3768 57.7782C53.3768 57.1945 53.6089 56.6346 54.0216 56.2217C54.8404 55.4059 55.4897 54.4362 55.9323 53.3685C56.3747 52.3006 56.6018 51.156 56.6 50.0001C56.6018 48.8443 56.3749 47.6995 55.9323 46.6317C55.4899 45.564 54.8404 44.5943 54.0216 43.7785C53.817 43.5742 53.6549 43.3316 53.544 43.0645C53.4333 42.7974 53.3763 42.5111 53.3763 42.222C53.3763 41.9329 53.4333 41.6466 53.544 41.3796C53.6549 41.1125 53.817 40.8699 54.0216 40.6655Z"
        fill="#262626"
      />
      <defs>
        <filter
          id="filter0_b_2954_9217"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9217"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9217"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
